<template lang="pug">
	.card
		p.card-title {{ card.title }}
		p.card-sub-text {{ card.subText }}
		p.card-desc {{ card.description }}
		p.date {{ dateCreated }}
		.bottom-bar
			p.asset-name {{ card.type }}
			p.asset-key {{ card.assetKey }}
</template>

<script>
import { months } from '@/lib/time';

export default {
	name : 'viewed-card',

	props : {
		card : {
			type     : [Object, Array],
			required : true,
		},
		cardMap : {
			type : Object,
		},
	},

	computed : {

		dateCreated() {

			const dateCreated = new Date( this.card.date );

			const month = dateCreated.getMonth();
			const year  = dateCreated.getFullYear();
			const day   = dateCreated.getDate();
			const date  = `${months[month]} ${day}, ${year}`;

			return date;
		},

		// cardInfo() {

		// 	const { card } = this;

		// 	const mapKeys      = Object.keys( card );
		// 	const computedInfo = mapKeys.reduce( ( cardInfo, key ) => {

		// 		const mapVal = card[key];

		// 		if ( mapVal.includes( '.' ) ) {
		// 			// we need to turn this into -> this.card.asset[facility][name]
		// 			const keyArr = mapVal.split( '.' );
		// 			const val    = keyArr.reduce( ( fullPath, partialKey ) => fullPath[partialKey], this.card.asset );
		// 			// so this should start at 'this.card.asset' -> 'facility' -> 'name' -> 'FRESNO HEAD WORKS'

		// 			cardInfo[key] = val;
		// 			return cardInfo;
		// 		}

		// 		cardInfo[key] = this.card.asset[mapVal];
		// 		return cardInfo;
		// 	}, {} );

		// 	return computedInfo;
		// },

	},
};
</script>

<style lang="scss">

.card {
	display: flex;
	flex-flow: column;
	align-items: flex-start;
	justify-content: space-between;

	> * {
		padding: 5px 15px;
	}

	.card-title {
		color: $input-color;
		font-size: 20px;
		font-weight: 500;
		padding-top: 12px;
	}

	.card-sub-text {
		color: $input-color;
		font-size: 14px;
		font-weight: 300;
		margin-bottom: 0;
		padding-bottom: 0;
	}

	.card-desc {
		color: $color-primary;
		font-size: 14px;
		font-weight: 300;
	}

	.date {
		font-size: 14px;
		font-weight: 300;
		padding-bottom: 12px;
	}

	.bottom-bar {
		background: $color-primary;
		display: flex;
		flex-flow: row nowrap;
		justify-content: space-between;
		padding: 8px 15px;
		width: 100%;

		.asset-name {
			color: white;
			font-size: 16px;
			text-transform: capitalize;
		}

		.asset-key {
			color: white;
			font-size: 14px;
		}
	}
}

</style>
